import { Component, OnInit } from '@angular/core';
import {Meta} from "@angular/platform-browser";
import { ActivatedRoute } from '@angular/router';
import { getMobilePlatform } from '../get-started/sms.service';
import { FacilityConfig } from 'src/environments/environment.interface';
import { EnvironmentService } from 'src/app/services/environment.service';
import { isSelfAppStoreRedirect } from './redirect-to-store.util';

@Component({
  selector: 'app-redirect-to-store',
  templateUrl: './redirect-to-store.component.html',
  styleUrls: ['./redirect-to-store.component.scss']
})
export class RedirectToStoreComponent implements OnInit {
  facilityConfig: FacilityConfig;
  appStoreUrl: string = '';
  playStoreUrl: string = '';

  constructor(private meta: Meta, private activeRoute: ActivatedRoute, private _environmentService: EnvironmentService) {
    this.facilityConfig = this._environmentService.getFacilityConfig();
    // Never fall back to /app-store — empty store URLs would redirect to self and flicker.
    this.appStoreUrl = this._environmentService.getLinkUrlById('appStore') || '';
    this.playStoreUrl = this._environmentService.getLinkUrlById('playStore') || '';

    this.meta.addTag({ name: 'og:title', content: "Download to join!" })
    this.meta.addTag({ name: 'og:image', content: "/assets/images/poster.png" })
  }

  ngOnInit() {
    let store = this.activeRoute.snapshot.queryParams['store'];
    if (!store) {
      store = getMobilePlatform() === 'android' ? 'google' : 'apple';
    }

    const targetUrl = store === 'google' ? this.playStoreUrl : this.appStoreUrl;
    if (targetUrl && !isSelfAppStoreRedirect(targetUrl)) {
      window.location.href = targetUrl;
      window.setTimeout(() => window.location.href = '/', 1000);
      return;
    }

    window.location.href = '/';
  }
}
